import { Delete, Edit, TramSharp } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import React, { useContext } from 'react'
import { CapitulosContext } from '../../pages/catalogos/CapitulosPage';

export const CapituloComponent = ({capitulo}) => {
   const {modalAgregaCapitulo, setModalAgregaCapitulo,obtenerCapitulos,modalEliminarCapitulo, setModalEliminarCapitulo, capituloSel, setCapituloSel} = useContext(CapitulosContext);

  return (
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        marginTop:6,
        backgroundColor:'white',
        borderRadius:10,
        padding:5,
        alignItems:'center'
      }}
    >
      <div
        style={{
          fontSize:14,
          
        }}
      >
        {capitulo.descripcion}
      </div>
      <div
        style={{
          fontSize:14,
          
        }}
      >
        {capitulo.descripcionCorta}
      </div>
      <div>
        <IconButton
          onClick={() => {
            setCapituloSel(capitulo)
            setModalAgregaCapitulo(true);
          }}
        >
        <Edit style={{color:'green'}} />
        </IconButton>
        <IconButton
          onClick={() => {
            setModalEliminarCapitulo(true);
            setCapituloSel(capitulo)
          }}
        >
          <Delete style={{color:'red'}} />
        </IconButton>
      </div>
    </div>
  )
}
